// The backend's system roles (SystemRoles in x-backend) — the values a role's
// systemRole takes, and what the Roles page offers. Not allpaypays' `appz` (admin)
// and `psp` (provider): no user ever has those, so anything keyed on them never
// matched. permissions.config.test.js keeps this list in step with the backend.
export const roles = {
    admin: {
        name: 'admin',
        systemRole: 'admin'
    },
    // Declared, but the backend does not let them sign in yet: their row scope
    // is not implemented.
    merchant: {
        name: 'merchant',
        systemRole: 'merchant'
    },
    agent: {
        name: 'agent',
        systemRole: 'agent'
    },
    // A gateway provider: bound to one gateway, and sees only its wallets,
    // payins and payouts. The backend scopes every row; this only shapes the UI.
    gateway: {
        name: 'gateway',
        systemRole: 'gateway'
    }
};

export const hiddenFieldsConfig = {
    [roles.admin.name]: {
        hideFields: []
    },
    [roles.merchant.name]: {
        hideFields: []
    },
    [roles.agent.name]: {
        hideFields: []
    },
    // What the backend hides from a gateway user (visibility-dto.yml): it nulls
    // these and refuses them as filter or sort paths, so their columns, editor
    // fields and search would only ever show blanks or errors. Matched on the
    // field id without a trailing "Id" and on its object, as fieldVisibilityConfig is.
    [roles.gateway.name]: {
        hideFields: [
            'merchantTerminal',
            'orderUuid',
            'merchantTransactionId',
            'conversionRate',
            'balanceCurrency',
            'balanceRate',
            'balanceAmount',
            'callbackUrl',
            'clientIp',
            'payload',
            'internalStateDescription',
            'totalIncludedCommission',
            'totalIncludedCommissionGwCost',
            'totalOntopCommission',
            'totalOntopCommissionGwCost',
            'totalAgentCommission',
            'commissionAgentJson',
            'commissionMerchantJson',
            'commissionGwJson',
            'modifiedBy',
            'modifiedReason',
            'gatewayApi',
            // Which settings rows a gateway links, and a payin or payout ran with:
            // the rows hold its bank logins and tokens, and are the admin's (V28).
            'payinSettings',
            'payoutSettings',
            'payinCallbackSettings',
            'payoutCallbackSettings',
            'payinAllowanceRule',
            'payoutAllowanceRule',
            'walletPayinRule',
            'walletPayoutRule',
            'currencyRateSource',
            'currencyRateKind',
            'currencyRateAdjustmentPercent',
            'tgBot',
            'tgSessionChat',
            'proxyList',
            'systemAccount',
            'systemAmount',
            'appeal'
        ]
    }
};
